import Const from 'constants';

const FilterLineupsByKeyPlayerStackCombinations = {
    filterLineupsByCheckedKeyPlayerStackCombo(checkedCombo) {
        return (dispatch, getState) => {
            const {combo, isChecked} = checkedCombo;
            const {filterLineupsByKeyPlayerStackCombinations} = getState();
            const combinations = filterLineupsByKeyPlayerStackCombinations.getCheckedCombinations();

            const checkedCombinations = Boolean(isChecked)
                ? [...combinations, combo]
                : combinations.filter((checkedCombo) => checkedCombo.getUnitId() !== combo.getUnitId());

            dispatch(this.setLineupsFilterByCheckedKeyPlayerStackCombinations(checkedCombinations));
        };
    },

    setLineupsFilterByCheckedKeyPlayerStackCombinations(checkedCombinations) {
        return (dispatch, getState) => {
            const {lineupKeyPlayerStackCombinationsMap} = getState();

            const lineupIds =
                lineupKeyPlayerStackCombinationsMap.getLineupIdsByCheckedCombinations(checkedCombinations);

            dispatch({
                type: Const.FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO,
                data: {
                    checkedCombinations,
                    lineupIds,
                },
            });
        };
    },
};

export default FilterLineupsByKeyPlayerStackCombinations;
